import React from "react";
import { Route, HashRouter as Router, Switch } from "react-router-dom";

import BrowseJournal from "./BrowseJournal";
import ComplaintJournal from "./ComplaintJournal";
import EditJournal from "./EditJournal";
import LoginJournal from "./LoginJournal";

const JournalRouter = () => (
  <Router>
    <Switch>
      <Route exact path="/我的/记录/浏览">
        <BrowseJournal />
      </Route>
      <Route exact path="/我的/记录/登录">
        <LoginJournal />
      </Route>
      <Route exact path="/我的/记录/编辑">
        <EditJournal />
      </Route>
      <Route exact path="/我的/记录/投诉">
        <ComplaintJournal />
      </Route>
    </Switch>
  </Router>
);

export default JournalRouter;
